module.exports = __webpack_public_path__ + "img/IMG_1178.e08e44a5.jpg";